export enum LiveChatOperationName {
  Initiate = 'InitiateChatAsync',
  MapConnection = 'MapConnectionAsync',
  SendMessage = 'SendChatToAgentAsync',
  Disconnect = 'DisconnectChatAsync'
}

export type LiveChatOperations = {
  [LiveChatOperationName.Initiate]: (message?: any) => Promise<void>;
  [LiveChatOperationName.SendMessage]: (message?: any) => Promise<void>;
  [LiveChatOperationName.Disconnect]: (message?: string) => Promise<void>;
};

export enum LiveChatCallbackName {
  Initiate = 'initiateChat',
  ReceiveMessage = 'ReceiveMessage',
  SentMessage = 'SendChatToAgent',
  MapConnection = 'mapConnection',
}

export type LiveChatCallbacks = {
  [LiveChatCallbackName.Initiate]: (message: string) => void;
  [LiveChatCallbackName.ReceiveMessage]: (message?: any) => void;
  [LiveChatCallbackName.SentMessage]: (message?: any) => void;
};


export interface Chat {
  callbacksName: LiveChatCallbackName;
  callbacks: LiveChatCallbacks;

  methodsName: LiveChatOperationName;
  methods: LiveChatOperations;
}
